import { ProgressIndicatorService } from './../../common/services/progress-indicator.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  closeBtnOptions,
  primaryButton,
  secondaryButton,
  spinnerOptions,
} from '../global-engagement.helper';
import { debounceTime, filter, Subject, takeUntil, switchMap, tap } from 'rxjs';
import { Size } from '@usitsdasdesign/dds-ng/shared';
import { Router } from '@angular/router';
import { GlobalEngagementService } from '../../http/global-engagement/global-engagement.service';
import {
  ExistingEngagementList,
  GlobalEngagementDeliveryCenterModel,
  GlobalEngagementMemberFirmModel,
  GlobalEngagementSubmissionResponseModel,
  GlobalEngagementSubmissionTypeModel,
} from '../../common/models/global-engagement.model';
import {
  OpportunityDetails,
  OpportunityList,
} from '../../common/models/opportunity-details.model';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { GlobalEngagementsConstant } from '../constants/global-engagements.constants';
import { SubmissionService } from '../../http/intake/submission.service';
import {
  opportunityTableColumns,
  engagementTableColumns,
} from './initiate-global-engagements.helper';
import { HttpErrorResponse } from '@angular/common/http';
import { tabContainerOptions } from '../global-engagement/global-eng-details/global-eng-details.helper';
import { PermissionCheckService } from '../../common/validations/permission-check.service';
import { configurationType, PermissionsObj } from '../../common/models/common-models';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { options, optionsShowMore } from '../../intake/initiate-submission/initiate-submission-helper';

@Component({
  selector: 'app-initiate-global-engagements',
  templateUrl: './initiate-global-engagements.component.html',
  styleUrl: './initiate-global-engagements.component.less',
})
export class InitiateGlobalEngagementsComponent implements OnInit, OnDestroy {
  htmlElementSize: Size = GlobalEngagementsConstant.UI_ELEMENT_SIZE;
  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  memberfirmOtherOption = GlobalEngagementsConstant.memberFirmOther;
  primaryButton = primaryButton;
  secondaryButton = secondaryButton;
  submissionType!: number;
  engagementType: string = GlobalEngagementsConstant.EMPTY_STRING;
  deliveryCenter!: number;
  memberFirm!: number;
  opportunityNumber: string = GlobalEngagementsConstant.EMPTY_STRING;
  engagementID!: number;
  submissionTypeList: SelectItemOptions[] = [];
  deliveryCenterList: SelectItemOptions[] = [];
  memberFirmList: SelectItemOptions[] = [];
  createNewLabel: string = GlobalEngagementsConstant.CREATE_NEW_LABEL;
  selectExistingLabel: string = GlobalEngagementsConstant.SELECT_EXISTING_LABEL;
  showCreateNewDiv: boolean = false;
  showSelectExistingDiv: boolean = false;
  otherFirmName: string = GlobalEngagementsConstant.EMPTY_STRING;
  clientName: string = GlobalEngagementsConstant.EMPTY_STRING;
  selectedOportunity: string = GlobalEngagementsConstant.EMPTY_STRING;
  totalCount: number = 0;
  pageNumber: number = 1;
  notFound: string = GlobalEngagementsConstant.EMPTY_STRING;
  opportunityList: any[] = [];
  pageSize: number = GlobalEngagementsConstant.PAGE_NUMBER;
  opportunityTableColumns = opportunityTableColumns;
  engagementTableColumns = engagementTableColumns;
  nonChangeOrder: string = GlobalEngagementsConstant.NON_CHANGE_ORDER;
  tooltipWidth: number = GlobalEngagementsConstant.TOOLTIP_WIDTH;
  showOpportunityDetails: boolean = false;
  showSelectOpportunity: boolean = false;
  showClientDetails: boolean = false;
  addClientManually: boolean = false;
  isDeliverCenterFieldDisabled: boolean = false;
  clientNumber!: number | null;
  public opportunityDetailsList: any[] = [];
  public defaultEmptyFields: string = GlobalEngagementsConstant.DEFAULT_VALUE;
  closeBtnOptions = closeBtnOptions;
  totalOpportunityCount: number = 0;
  activeOpportunityCount: number = 0;
  selectedTabCode: string = 'active';
  selectTabIndex: number = 0;
  tabContainerOptions = tabContainerOptions;
  options = GlobalEngagementsConstant.TOOLTIP_OPTIONS;
  removeOpportunityText: string = GlobalEngagementsConstant.REMOVE_OPPORTUNITY_TEXT;
  optionsShowMore: ButtonOptions = optionsShowMore;
  optionsShowLessBtn: ButtonOptions = options;
  emptySpace : string = GlobalEngagementsConstant.EMPTY_STRING;
  isShowMoreVisible: boolean = true;
  unsubscriber$: Subject<void> = new Subject<void>();
  configData: configurationType[] = [];
  confidentialOppertunityWarnNoteText: string = GlobalEngagementsConstant.EMPTY_STRING;
  confidentialOppertunityWarnNoteHeader : string = GlobalEngagementsConstant.EMPTY_STRING;
  isOpportunityConfidential: boolean = false;
  

  public tabs = [
    {
      label: 'Active',
      code: 'active',
      count: this.activeOpportunityCount,
    },
    {
      label: 'All opportunities',
      code: 'all',
      count: this.totalOpportunityCount,
    },
  ];
  permissionObj: PermissionsObj = {} as PermissionsObj;

  private readonly searchOpportunityQuery$: Subject<string> =
    new Subject<string>();
  showDropdown: boolean = false;
  isSpinnerVisible: boolean = false;
  private currentSearchTerm: string = ''; // Store the current search term
  private loadingMore: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly globalEngagementService: GlobalEngagementService,
    private readonly submissionService: SubmissionService,
    private readonly ProgressIndicatorService: ProgressIndicatorService,
    private readonly permissionCheck: PermissionCheckService
  ) {}

  spinnerOptions = spinnerOptions;

  ngOnInit(): void {
    this.ProgressIndicatorService.show();
    this.fetchPermissions();
    this.getLabelConfiguration();

    this.getSubmissionType();
    this.searchOpportunityQuery$
      .pipe(
        debounceTime(GlobalEngagementsConstant.SEARCH_DEBOUNCE_TIME),
        filter(
          (key) =>
            !!key &&
            key.length > GlobalEngagementsConstant.SEARCH_STRING_LIMIT_2
        ),
        // switchMap is used here to handle the race condition that can occur when the user types quickly in the search box.
        // It cancels any pending requests and only executes the latest one, ensuring that we only display the results for the most recent search term.
        switchMap((searchTerm: string) => {                    
          this.currentSearchTerm = searchTerm; // Store the search term
          return this.fetchOpportunitySearchResult(1, this.selectedTabCode, searchTerm);
        }),
        takeUntil(this.#unsubscriber$)
      )
      .subscribe();
  }

  fetchPermissions(): void {
    this.permissionCheck.permissionsObj$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((permissions: PermissionsObj) => {
        this.permissionObj = { ...permissions };
      });
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }

  clickShowMoreOrShowLess(event: Event, section: string): void {
    if (section === 'showMore') {
      this.isShowMoreVisible = true;
    } else if (section === 'showLess') {
      this.isShowMoreVisible = false;
    }
  }

  getLabelConfiguration(): void {
    this.submissionService
      .getIntakeConfigurations()
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: configurationType[]) => {
          if (response) {
          this.configData = response;
          // Fetch label value for a specific key  'CONFIDENTIAL_OPPORTUNITY_HEADER'
          const confidentialOppertunityKey =  'CONFIDENTIAL_OPPORTUNITY_BODY';
          this.confidentialOppertunityWarnNoteText = this.getLabelValueByKey(confidentialOppertunityKey);
          const confidentialOppertunityHeader =  'CONFIDENTIAL_OPPORTUNITY_HEADER';
          this.confidentialOppertunityWarnNoteHeader = this.getLabelValueByKey(confidentialOppertunityHeader);

        }},
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  getLabelValueByKey(labelKey: string): string {

    const labelObject = this.configData.find(
      (item: { appConfigurationLabelKey: string }) =>
        item.appConfigurationLabelKey === labelKey
    );
  
    return labelObject?.appConfigurationLabelValue || '';
   
  }

  getSubmissionType(): void {
    this.globalEngagementService
      .getSubmissionTypes()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: GlobalEngagementSubmissionTypeModel[]) => {
          if (response) {
            const convertedArray = response.map(
              (item: GlobalEngagementSubmissionTypeModel) => ({
                value: item.submissionTypeId,
                heading: item.submissionTypeName,
              })
            );
            this.submissionTypeList = convertedArray;
            this.ProgressIndicatorService.hide();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.ProgressIndicatorService.hide();
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  getDeliveryCenter(newSubmission:boolean): void {
    this.globalEngagementService
      .getDeliveryCenter(newSubmission)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: GlobalEngagementDeliveryCenterModel[]) => {
          if (response) {
            const convertedArray = response.map(
              (item: GlobalEngagementDeliveryCenterModel) => ({
                value: item.deliveryCenterId,
                heading: item.deliveryCenterName,
              })
            );
            this.deliveryCenterList = convertedArray;
            if(convertedArray.length === 1){
              this.deliveryCenter = convertedArray[0].value;
              this.isDeliverCenterFieldDisabled = true;
            }

          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  getMemberFirmDetails(): void {
    this.globalEngagementService
      .getMemberFirmDetails()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: GlobalEngagementMemberFirmModel[]) => {
          if (response) {
            const convertedArray = response.map(
              (item: GlobalEngagementMemberFirmModel) => ({
                value: item.memberFirmId,
                heading: item.memberFirmName,
              })
            );
            this.memberFirmList = convertedArray;
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  onEngagementTypeChange(event: string): void {
    this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
    this.opportunityList = [];
    this.totalCount = 0;
    this.showDropdown = false;
    if (event === this.createNewLabel) {
      this.getDeliveryCenter(true);
      this.getMemberFirmDetails();
      this.showCreateNewDiv = true;
      this.showSelectExistingDiv = false;
      this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
      this.opportunityDetailsList = [];
      this.totalCount = 0;
      this.showDropdown = false;
      this.showOpportunityDetails = false;
      this.selectedOportunity = GlobalEngagementsConstant.EMPTY_STRING;
      this.opportunityList = [];
    } else if (event === this.selectExistingLabel) {
      this.showCreateNewDiv = false;
      this.showSelectExistingDiv = true;
      this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
      this.opportunityList = [];
      this.totalCount = 0;
      this.showDropdown = false;
      this.showOpportunityDetails = false;
      this.selectedOportunity = GlobalEngagementsConstant.EMPTY_STRING;
      this.opportunityDetailsList = [];
    }
  }

  removeOpportunity(): void {
    this.showOpportunityDetails = false;
    this.selectedOportunity = GlobalEngagementsConstant.EMPTY_STRING;
    this.opportunityList = [];
    this.opportunityDetailsList = [];
    this.showDropdown = false;
    this.opportunityDetailsList = [];
    this.isOpportunityConfidential = false;
  }

  isSubmitDisabled(): boolean {

    if (this.isOpportunityConfidential) {
        return false;  
    }

    if (!this.submissionType) {
      return false;
    }
    if (
      !this.engagementType ||
      this.engagementType.trim() === GlobalEngagementsConstant.EMPTY_STRING
    ) {
      return false;
    }
    if (this.engagementType === this.createNewLabel) {
      if (!this.deliveryCenter) {
        return false;
      }
      if (!this.memberFirm) {
        return false;
      }
      if (
        this.memberFirm === GlobalEngagementsConstant.memberFirmOther &&
        (!this.otherFirmName ||
          this.otherFirmName.trim() === GlobalEngagementsConstant.EMPTY_STRING)
      ) {
        return false;
      }
      if (this.showClientDetails) {
        if (this.addClientManually) {
          if (
            !this.clientName ||
            this.clientName.trim() === GlobalEngagementsConstant.EMPTY_STRING
          ) {
            return false;
          }
        } else {
          if (!this.clientNumber) {
            return false;
          }
        }
      } else {
        if (
          !this.opportunityDetailsList ||
          this.opportunityDetailsList.length === 0
        ) {
          return false;
        }
      }
      return true;
    }
    if (this.engagementType === this.selectExistingLabel) {
      if (
        !this.opportunityDetailsList ||
        this.opportunityDetailsList.length === 0
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  fieldCleared(): void {
    this.opportunityList = [];
    this.selectedOportunity = GlobalEngagementsConstant.EMPTY_STRING;
    this.showDropdown = false;
    this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
  }

  selectOpportunityChanged(event: string): void {
    this.totalCount = 0;
    this.pageNumber = 1;
    if (event.length > 2 && event !== GlobalEngagementsConstant.EMPTY_STRING) {
      this.searchOpportunityQuery$.next(event);
    } else {
      this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
      this.opportunityList = [];
      this.totalCount = 0;
      this.showDropdown = false;
    }
  }

  fetchOpportunitySearchResult(pageNumber: number, tabCode: string, searchTerm: string = this.currentSearchTerm): any {
    this.isSpinnerVisible = true;
    if (this.engagementType === this.createNewLabel) {
      return this.submissionService // Return the observable
        .getOpportunityDetails(
          searchTerm, 
          pageNumber,
          this.pageSize,
          tabCode
        )
        .pipe(
          takeUntil(this.#unsubscriber$),
          tap({
            next: (opportunity: OpportunityList) => {
              if (opportunity?.totalOpportunityCount > 0) {
                this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
                if (pageNumber === 1) {
                  this.opportunityList = opportunity?.opportunities;
                } else {
                  this.opportunityList = [
                    ...this.opportunityList,
                    ...opportunity?.opportunities,
                  ];
                }
                this.totalCount = opportunity?.totalOpportunityCount;
                this.tabs[0].count = opportunity?.activeOpportunityCount;
                this.tabs[1].count = opportunity?.totalOpportunityCount;
                if (opportunity.activeOpportunityCount == 0) {
                  if (this.selectTabIndex == 0) {
                    this.selectTabIndex = 1;
                    this.tabChanged(this.tabs[1].code);
                  }
                } else {
                  if (this.selectTabIndex == 1) {
                    this.selectTabIndex = 0;
                    this.tabChanged(this.tabs[0].code);
                  }
                }
                if (this.opportunityList.length > 0) {
                  this.showDropdown = true;
                }
              } else {
                this.notFound = 'Not Found';
                this.opportunityList = [];
                this.totalCount = 0;
                this.showDropdown = false;
              }
              this.isSpinnerVisible = false;
            },
            error: (err: HttpErrorResponse) => {
              this.isSpinnerVisible = false;
              console.error('Error fetching submission types', err);
            }
          })
        );
    } else {
      const requestBody: any = {
        SearchTerm: searchTerm, 
        PageNumber: pageNumber,
        PageSize: this.pageSize,
      };

      return this.globalEngagementService // Return the observable
        .getExistingEnagementDetails(requestBody)
        .pipe(
          takeUntil(this.#unsubscriber$),
          tap({
            next: (opportunity: ExistingEngagementList) => {
              if (opportunity.totalCount > 0) {
                this.notFound = GlobalEngagementsConstant.EMPTY_STRING;
                if (pageNumber === 1) {
                  this.opportunityList = opportunity?.data;
                } else {
                  this.opportunityList = [
                    ...this.opportunityList,
                    ...opportunity?.data,
                  ];
                }
                this.totalCount = opportunity?.totalCount;
                if (this.opportunityList.length > 0) {
                  this.showDropdown = true;
                }
              } else {
                this.notFound = 'Not Found';
                this.opportunityList = [];
                this.totalCount = 0;
                this.showDropdown = false;
              }
              this.isSpinnerVisible = false;
            },
            error: (err: HttpErrorResponse) => {
              this.isSpinnerVisible = false;
              console.error('Error fetching submission types', err);
            }
          })
        );
    }
  }

  fetchOpportunitySearchResultMore(event: any): void {   
    if (this.loadingMore) {
      // Prevent multiple simultaneous calls to load more
      return;
    }
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      if (this.pageNumber < this.totalCount / this.pageSize) {
        this.loadingMore = true;
        this.pageNumber++;
        this.isSpinnerVisible = true; 
        this.fetchOpportunitySearchResult(
          this.pageNumber,
          this.selectedTabCode,
          this.currentSearchTerm 
        ).subscribe(() => {
          this.isSpinnerVisible = false; 
          this.loadingMore = false;
        });
      }
    }
  }

  getNumberOfSplits(fetchType: string): string {
    let splits = GlobalEngagementsConstant.EMPTY_STRING;
    for (let offering of this.opportunityDetailsList[0]?.offering) {
      splits += `${offering} \n`;
    }
    return 'true';
  }

  fetchOpportunityDetails(
    opportunity: OpportunityDetails,
    fetchType: string
  ): void {
    this.opportunityList = [];
    this.showDropdown = false;
    this.showOpportunityDetails = true;
    this.opportunityDetailsList = [opportunity];
    this.opportunityNumber = this.opportunityDetailsList[0]?.opportunityNumber;
    this.selectedOportunity = GlobalEngagementsConstant.EMPTY_STRING;
    this.isOpportunityConfidential = opportunity?.isConfidentialOpportunity ?? false;
  }

  notAvailabeStateChanged(event: boolean): void {
    if (event) {
      this.showClientDetails = true;
      this.opportunityDetailsList = [];
    } else {
      this.showClientDetails = false;
    }
  }

  addManuallyChecked(event: boolean) {
    if (event) {
      this.addClientManually = true;
      this.clientNumber = null;
    } else {
      this.addClientManually = false;
    }
  }

  onSubmit(): void {
    this.ProgressIndicatorService.show();
    if (this.engagementType === this.createNewLabel) {
      const requestBody = {
        SubmissionTypeId: this.submissionType,
        DeliveryCenterId: this.deliveryCenter,
        MemberFirmId: this.memberFirm,
        MemberFirmOther: this.otherFirmName ? this.otherFirmName : null,
        OpportunityNumber: this.opportunityDetailsList[0]?.opportunityNumber,
        ClientNumber: this.clientNumber ? this.clientNumber : null,
        ClientName: this.clientName ? this.clientName : null,
        EngagementId: 0,
      };

      this.globalEngagementService
        .postInitiateGlobalEngagement(requestBody)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (res: GlobalEngagementSubmissionResponseModel) => {
            if (res) {
              this.router.navigate(
                ['globalEngagements/details', res.engagementId],
                {
                  state: { submissionId: res.engagementId },
                }
              );
            }
            this.ProgressIndicatorService.hide();
          },
          error: (err: Error) => {
            console.error('Error initiating external communication', err);
          },
        });
    } else {
      const requestBody = {
        SubmissionTypeId: this.submissionType,
        OpportunityNumber: this.opportunityDetailsList[0]?.jupiterOpportunityID,
        EngagementId: this.opportunityDetailsList[0]?.engagementID,
      };

      this.globalEngagementService
        .postInitiateGlobalEngagement(requestBody)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (res: GlobalEngagementSubmissionResponseModel) => {
            if (res) {
              this.router.navigate(
                ['globalEngagements/details', res.engagementId],
                {
                  state: { submissionId: res.engagementId },
                }
              );
            }
            this.ProgressIndicatorService.hide();
          },
          error: (err: Error) => {
            console.error('Error initiating external communication', err);
          },
        });
    }
  }

  tabChanged(event: string): void {
    this.selectedTabCode = event;
    this.fetchOpportunitySearchResult(1, this.selectedTabCode, this.currentSearchTerm)
        .subscribe();
}
  clientSearched(clientNumber: number): void {
    this.clientNumber = clientNumber;
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
